<template>
  <div class="section py-0">
    <div class="section">
      <div class="columns">
        <div class="column">
          <h1 class="title is-1">
            {{ org(orgId).name }}
          </h1>
        </div>
        <div class="column is-narrow is-flex">
          <IconRow
            :data="orgProduct(orgId)"
            dataSize="is-medium"
            class="mr-2"
          />
          <OrgTag
            v-if="'license_type' in org(orgId)"
            :data="org(orgId).license_type"
            :test="org(orgId).test"
            dataSize="is-medium"
          />
          <!-- <b-icon class="ml-3" icon="paint-brush" size="is-medium"></b-icon>
          <b-icon class="ml-3" icon="pray" size="is-medium"></b-icon>
          <b-icon class="ml-3" icon="laptop-code" size="is-medium"></b-icon>
          <b-tag class="ml-3" type="is-gold" size="is-medium"> Haupt </b-tag> -->
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns is-desktop">
        <div class="column is-full is-half-desktop">
          <div class="is-flex is-justify-content-space-between">
            <h4 class="title is-3">Profil</h4>
            <section class="b-tooltips">
              <!-- <b-button class="is-light" size="">
                  <b-icon icon="envelope"></b-icon>
                </b-button> -->
              <b-tooltip
                :label="
                  org(orgId).locked
                    ? 'Organisation ist momentan gesperrt.'
                    : 'Organisation ist momentan freigeschaltet.'
                "
                position="is-top"
              >
                <b-button
                  class="is-light"
                  :class="org(orgId).locked ? 'is-warning' : 'is-success'"
                  @click="confirmLockOrg"
                >
                  <b-icon icon="ban"></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip label="Organisation löschen" position="is-top">
                <b-button
                  v-if="orgIdInt !== 1"
                  class="is-light"
                  @click="confirmDeleteOrg"
                >
                  <b-icon icon="trash-alt"></b-icon>
                </b-button>
              </b-tooltip>
            </section>
          </div>
          <OrgSimple
            :org="org(orgId)"
            :comment="true"
            @submit="updateOrg"
            :disabled="false"
          />
        </div>
        <div class="column is-full is-half-desktop">
          <div class="is-flex">
            <h4
              class="title is-3 is-clickable"
              :class="active === 0 ? '' : 'is-inactive'"
              @click="active = 0"
            >
              Berechtigungen
            </h4>
            <h4 class="title is-3 is-inactive mx-3">|</h4>
            <h4
              class="title is-3 is-clickable"
              :class="active === 1 ? '' : 'is-inactive'"
              @click="active = 1"
            >
              Accounts
            </h4>
          </div>
          <div v-if="active === 0">
            <OrgLicense
              class="block"
              :data="org(orgId)"
              @submit="updateOrg"
              minHeight="500px"
            >
              <template v-slot:subscription>
                <b-field label="Abonnierte Produkte">
                  <ProductView
                    height="190px"
                    :data="orgProduct(orgId)"
                    :dataOwned="orgGroup(orgId)"
                    @updateProduct="updateProducts"
                    @groupClicked="updatePermissionGroup"
                  />
                </b-field>
              </template>
            </OrgLicense>
          </div>
          <div v-else>
            <OrgAccounts
              :data="org(orgId)"
              minHeight="504px"
              :userListHeight="userListHeight"
              :userListMaxHeight="userListMaxHeight"
              :orgListHeight="orgListHeight"
              orgListMaxHeight="258px"
              @submit="updateOrg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ProductView from "@/components/editProduct/ProductListBox.vue";
// import InputBox from '@/components/InputBox.vue';
import OrgSimple from "@/components/editOrg/OrgSimple.vue";
import OrgLicense from "@/components/editOrg/OrgLicense.vue";
import OrgAccounts from "@/components/editOrg/OrgAccounts.vue";

// import UserTag from '@/components/editUser/UserTag.vue';
import IconRow from "@/components/helper/IconRow.vue";
import OrgTag from "@/components/editOrg/OrgTag.vue";

export default {
  name: "ViewOrg",
  components: {
    ProductView,
    // InputBox,
    // UserTag,
    OrgSimple,
    OrgLicense,
    OrgAccounts,
    IconRow,
    OrgTag
  },
  props: ["orgId"],
  data() {
    return {
      active: 1
    };
  },
  computed: {
    ...mapGetters({
      users: "user/data",
      org: "org/dataById",
      orgGroup: "org/group/dataByParentId",
      orgProduct: "org/product/dataByParentId",
      orgUser: "org/user/dataByParentId",
      orgSubs: "org/sub/dataByParentId"
    }),
    orgIdInt() {
      return parseInt(this.orgId, 10);
    },
    userListHeight() {
      if (!this.orgSubs(this.orgIdInt).length) {
        return "375px";
      }
      return "auto";
    },
    userListMaxHeight() {
      if (!this.orgSubs(this.orgIdInt).length) {
        return "100%";
      }
      return "182px";
    },
    orgListHeight() {
      if (!this.orgUser(this.orgIdInt).length) {
        return "258px";
      }
      return "100%";
    }
  },
  methods: {
    changeProductSubscription(event) {
      console.log(event);
    },
    updateOrg(payload) {
      // const cleanPayload = payload;
      // delete cleanPayload.name;
      // delete cleanPayload.contract_renews;
      // delete cleanPayload.main_license_org_id;
      // delete cleanPayload.user_amount;
      this.$store.dispatch("org/UPDATE", payload);
    },
    deleteOrg() {
      this.$store.dispatch("org/DELETE", { id: this.orgIdInt });
    },
    confirmDeleteOrg() {
      this.$buefy.dialog.confirm({
        title: "Organisation löschen",
        message: `Sind Sie sicher, dass Sie die Organisation <b>${
          this.org(this.orgId).name
        }</b> und <b>die ${
          this.orgUser(this.org(this.orgId)).length
        } Nutzer</b> der Organisation <b>löschen</b> wollen? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Organisation löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteOrg()
      });
    },
    lockOrg() {
      this.$store.dispatch("org/UPDATE", {
        id: this.orgIdInt,
        locked: !this.org(this.orgId).locked
      });
    },
    confirmLockOrg() {
      if (this.org(this.orgId).locked) {
        this.lockOrg();
      } else {
        this.$buefy.dialog.confirm({
          title: "Organisation sperren",
          message: `Sind Sie sicher, dass Sie die Organisation <b>${
            this.org(this.orgId).name
          }</b> sperren wollen?`,
          confirmText: "Organisation sperren",
          cancelText: "Abbrechen",
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => this.lockOrg()
        });
      }
    },
    updateProducts(payload) {
      this.$store.dispatch("org/product/UPDATE", {
        id: this.orgIdInt,
        product_id: payload.id,
        subscribed: payload.value
      });
    },
    updatePermissionGroup(data) {
      this.$store.dispatch("org/group/UPDATE", {
        id: this.orgIdInt,
        ...data
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.is-inactive {
  color: rgb(184, 184, 184);
  &:hover {
    color: hsl(0, 0%, 62%);
  }
}
</style>
